import * as month from './month'
import * as general from './general'

export const optionsHelper = {
  month,
  general,
}
